import NextLink from 'next/link';
import PropTypes from 'prop-types';
import { useMemo } from 'react';

import Anchor from 'components/Anchor';

import { getObjWithMostOccurrences } from 'lib/array';
import { toCategoryLink, toSubcategoryLink } from 'lib/links';

const TITLE_FALLBACK = 'Confira essas ofertas selecionadas';

const HeadingContentWithCategoryLinks = ({ categories, subcategories }) => {
  const subcategoryWithMostOccurrences = useMemo(() =>
    getObjWithMostOccurrences(subcategories, 'subcategoryId')
  );

  const firstOfferCategory = categories[0];

  if (categories.length === 0 || subcategories.length === 0) {
    return TITLE_FALLBACK;
  }

  return (
    <>
      Promoção de{' '}
      <NextLink
        href={toCategoryLink(firstOfferCategory.categorySlug)}
        prefetch={false}
        passHref
      >
        <Anchor>
          {firstOfferCategory.categoryName ??
            firstOfferCategory.categorySlug.replace(/-/g, ' ')}
        </Anchor>
      </NextLink>
      {', '}
      <NextLink
        href={toSubcategoryLink(subcategoryWithMostOccurrences.subcategorySlug)}
        prefetch={false}
        passHref
      >
        <Anchor>
          {subcategoryWithMostOccurrences.subcategoryName ??
            subcategoryWithMostOccurrences.subcategorySlug.replace(/-/g, ' ')}
        </Anchor>
      </NextLink>{' '}
      e mais é no Promobit
    </>
  );
};

HeadingContentWithCategoryLinks.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      categoryId: PropTypes.number.isRequired,
      categoryName: PropTypes.string.isRequired,
      categorySlug: PropTypes.string.isRequired,
    })
  ).isRequired,
  subcategories: PropTypes.arrayOf(
    PropTypes.shape({
      subcategoryId: PropTypes.number.isRequired,
      subcategoryName: PropTypes.string.isRequired,
      subcategorySlug: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default HeadingContentWithCategoryLinks;
